<template>
    <div>
        <div class="holder">
            <h2 id="page-header"><router-link to="/">My Arlington -</router-link><router-link to="/foodResources"> Food Assistance Resources</router-link></h2>
            <div id="blurb">
              <p>
                 Arlington has many food assistance resources available to ensure that any resident who needs help can get the food they need to feed themselves and their families. 
                 This map shows the locations of food pantries, food distributions, and meal programs. For information on additional food assistance resources, please call 703-228-1300 or go to the
                 <a href="https://www.arlingtonva.us/Government/Departments/DHS/Food-Assistance">Arlington County food assistance resources website</a>.
                Contact <a href="mailto:foodassistance@arlingtonva.us">foodassistance@arlingtonva.us</a> with any questions about the content of this map.
              </p>
              <br/>
            </div>
        </div>
        <div class="layer-page">
            <div class="widget one-third filter-pane">
                <div class="filter-header" id="mobile-menu" v-show="isMobile || mobileMenu === false" @click="mobileMenu = !mobileMenu">
                    Filters and Location
                    <svg v-show="!mobileMenu" style="float: right" class="icon"><use xlink:href="#icon-plus"></use></svg>
                    <svg v-show="mobileMenu" style="float: right" class="icon"><use xlink:href="#icon-minus"></use></svg>
                </div>
                <div id="filters-and-settings" v-show="!isMobile || mobileMenu">
                    <div class="filter-container">
                        <div class="filter-header" @click="filtersToggle" v-show="!isMobile" >
                            <span>Filters
                                <svg v-show="filtersExpanded" style="float: right" class="icon"><use xlink:href="#icon-minus"></use></svg>
                                <svg v-show="!filtersExpanded" style="float: right" class="icon"><use xlink:href="#icon-plus"></use></svg>
                                <div style="clear: both"></div>
                            </span>
                        </div>
                        <div class="filterList" v-show="filtersExpanded || mobileMenu"><br/>
                            <div class="filter-item filter-category">Type</div>
                            <div class="filter-item">
                              <input v-model="typeSelected" :value="'FOOD PANTRY'" type="checkbox" />
                              <span class="tooltip">&nbsp;Food Pantry
                                <span class='box blue'></span>
                              </span>
                              <span class="icon"></span>

                            </div>
                            <div class="filter-item">
                              <input v-model="typeSelected" :value="'SCHOOL MEALS'" type="checkbox" />
                              <span class="tooltip">&nbsp;School Meals
                                <span class='box red'></span>
                              </span>
                            </div>
                            <div class="filter-item">
                              <input v-model="typeSelected" :value="'PREPARED MEALS'" type="checkbox" />
                              <span class="tooltip">&nbsp;Prepared Meals
                                <span class='box green'></span>
                              </span>
                            </div>
                            <div class="filter-item">
                              <input v-model="typeSelected" :value="'DISCOUNT GROCERIES'" type="checkbox" />
                              <span class="tooltip">&nbsp;Discount Groceries
                                <span class='box purple'></span>
                              </span>
                            </div>
                            <br>
                            <div class="filter-item filter-category">Eligibility Features</div>
                            <div class="filter-item">
                              <input v-model="filterSelected" :value="'Eligibility Requirement'" type="checkbox" />
                              <span class="tooltip">&nbsp;Eligibility requirement</span>
                            </div>
                            <div class="filter-item">
                              <input v-model="filterSelected" :value="'No Photo ID Required'" type="checkbox" />
                              <span class="tooltip">&nbsp;No Photo ID required</span>
                            </div>
                            <div class="filter-item">
                              <input v-model="filterSelected" :value="'No Registration Required'" type="checkbox" />
                              <span class="tooltip">&nbsp;No Registration required</span>
                            </div>
                            <div class="filter-item">
                              <input v-model="filterSelected" :value="'Restricted access (only members of these communities)'" type="checkbox" />
                              <span class="tooltip">&nbsp;Restricted access
                                  <span class="tooltiptext">Only members of these communities</span>
                              </span>
                            </div>
                            <div class="filter-item">
                              <input v-model="filterSelected" :value="'age_restriction'" type="checkbox" @change="ageRestrictionChange($event)" />
                              <span class="tooltip">&nbsp;Age restrictions</span>
                            </div>
                            <div class="filter-item filter-item-nested" v-if="filterSelected.includes('age_restriction')">
                                <input v-model="filterSelected" :value="'Age restrictions - for children (or families of children) only'" type="checkbox" />
                                <span class="tooltip"> Children
                                  <span class="tooltiptext">For Children or Families with Children</span>
                                </span>
                            </div>
                            <div class="filter-item filter-item-nested" v-if="filterSelected.includes('age_restriction')">
                                <input v-model="filterSelected" :value="'Age restrictions - for seniors only'" type="checkbox" />
                                <span class="tooltip">  Seniors
                                  <span class="tooltiptext">For Seniors only</span>
                                </span>
                            </div>
                            <div class="filter-item">
                              <input v-model="filterSelected" :value="'Income maximum for eligibility'" type="checkbox" />
                              <span class="tooltip">&nbsp;Income maximum</span>
                            </div>
                        </div>

                         <div class="filterList" v-show="filtersExpanded || mobileMenu"><br/>
                            <div class="filter-item filter-category">Program Features</div>
                            <div class="filter-item">
                              <input v-model="filterSelected" :value="'Delivery Available'" type="checkbox" />
                              <span class="tooltip">&nbsp;Delivery Available</span>
                            </div>
                            <div class="filter-item">
                              <input v-model="filterSelected" :value="'Prepared Meals'" type="checkbox" />
                              <span class="tooltip">&nbsp;Prepared Meals</span>
                            </div>
                            <div class="filter-item">
                              <input v-model="filterSelected" :value="'Grocery Items'" type="checkbox" />
                              <span class="tooltip">&nbsp;Grocery Items</span>
                            </div>
                            <div class="filter-item">
                              <input v-model="filterSelected" :value="'Fresh Produce'" type="checkbox" />
                              <span class="tooltip">&nbsp;Fresh Produce</span>
                            </div>
                            <div class="filter-item">
                              <input v-model="filterSelected" :value="'Accepts SNAP'" type="checkbox" />
                              <span class="tooltip">&nbsp;Accepts SNAP</span>
                            </div>
                        </div>

                         <div class="filterList" v-show="filtersExpanded || mobileMenu"><br/>
                            <div class="filter-item filter-category">Other Services Provided</div>
                            <div class="filter-item">
                              <input v-model="filterSelected" :value="'Other services provided - Diapers'" type="checkbox" />
                              <span class="tooltip">&nbsp;Diapers</span>
                            </div>
                            <div class="filter-item">
                              <input v-model="filterSelected" :value="'Other services provided - Baby formula'" type="checkbox" />
                              <span class="tooltip">&nbsp;Baby Formula</span>
                            </div>
                            <div class="filter-item">
                              <input v-model="filterSelected" :value="'Other services provided - Financial assistance'" type="checkbox" />
                              <span class="tooltip">&nbsp;Financial Assistance</span>
                            </div>
                            <div class="filter-item">
                              <input v-model="filterSelected" :value="'Other services provided - Clothing'" type="checkbox" />
                              <span class="tooltip">&nbsp;Clothing</span>
                            </div>
                        </div>
                        <div class="filterList" v-show="filtersExpanded || mobileMenu"><br/>
                            <div class="filter-item filter-category">Public Transit</div>
                            <div class="filter-item">
                                <input v-model="transitSelected" :value="'Bus'" type="checkbox"/>
                                <span class="tooltip"> &nbsp;Bus</span>
                            </div>
                            <div class="filter-item">
                                <input v-model="transitSelected" :value="'Metro'" type="checkbox"/>
                                <span class="tooltip"> &nbsp;Metro</span>
                            </div>
                          </div>
                    </div>

                    <h3>Zoom to Location</h3>
                    <div class="filter-container zoom-container">
                        <label for="addressSearch">Address</label>
                        <br/>
                        <gmap-autocomplete ref="autocomplete" @place_changed="placeChanged"></gmap-autocomplete>
                    </div>

                    <div class="filter-container">
                      <button class="link filter-header" @click="clearAll">Clear All</button>
                    </div>
                </div>
            </div>
            <div class="widget full-map-pane toggle-window two-thirds">
                <div style="position: relative; top: 0">
                  <h3 class="toggle-bar">
                    <a :class="showMap === true ? 'toggle-link' : 'toggle-link active'" @click="showMap = true">Map</a>
                    <a :class="showMap === false ? 'toggle-link' : 'toggle-link active'" @click="showMap = false" id="list-link">List</a>
                  </h3>
                </div>
                <gmap-map
                    v-show="showMap"
                    :center="mapCenter"
                    :zoom="zoomLevel"
                    :options="mapStyles"
                    id="vue-map-container"
                    >
                    <gmap-marker v-for="item in filteredItems"
                      :key="item.location_name"
                      :position="item"
                      :icon="item.icon"
                      :options="shapeOptions"
                      @click="(e) => shapeClick(item, e)">
                    </gmap-marker>
                    <!-- Common Info Window -->
                    <gmap-info-window
                      :opened="selectedInfoWindowPosition !== null"
                      :position="selectedInfoWindowPosition"
                      @closeclick="infoWindowCloseClick">
                        <div class="info-window" v-for="(selected,index) in selectedItem.items" :key="index">
                            <h3 class="info-window-header"><b>{{getLocation(selected)}}</b><span class='box' :class="selected['color']" style="float: left"></span></h3>
                            <span>{{selected['Location address']}}</span><br/>
                            <span><b>Hours:</b> {{selected['Day']}}{{selected['Times']}}</span><br>
                            <span v-if="selected['Website'] && selected['Website'] != 'N/A'"><a target="_blank" :href="selected['Website']">Website</a><br/></span>
                            <br/>
                            <span><b>Contact Name:</b> {{selected['Name'] || 'N/A'}}<br/></span>
                            <span><b>Contact Email:</b> {{selected['Email'] || 'N/A'}}<br/></span>
                            <span><b>Contact Phone:</b> {{selected['Phone'] || 'N/A'}}<br></span>
                            <span><b>Info:</b> {{selected['Description'] || 'N/A'}}</span><br>
                            <span><b>Eligibility Requirements:</b> {{selected['Eligibility requirements'] || 'N/A'}}</span><br>
                            <span><b>Registration Contact:</b> {{selected['Registration Contact'] || 'N/A'}}</span><br>
                            <span><b>Languages Spoken other than English:</b> {{selected['Languages Spoken other than English'] || 'N/A'}}</span><br>
                            <span><b>Metro:</b> {{selected['Metro'] || 'N/A'}}<br/></span>
                            <span><b>Bus:</b> {{selected['Bus'] || 'N/A' }}<br/></span>
                            <br><br>
                          </div>
                    </gmap-info-window>

                    <!-- Location Markers -->
                    <gmap-marker v-if="selectedCoordinates" :position="selectedCoordinates" :radius="24"></gmap-marker>
                    <gmap-polygon v-if="civicAssocationsSelected" :path="civicAssocationsSelected.paths" :options="locationOptions"></gmap-polygon>
                    <GmapCircle v-if="selectedCoordinates && radiusSelected" :center="selectedCoordinates" :radius="radiusSelected*1609" :visible="true" :options="{fillColor:'blue',fillOpacity:0.1,strokeWeight:0.7,strokeColor:'blue'}"></GmapCircle>
                </gmap-map>
                <div v-show="!showMap" class="list-pane">
                  <div v-for="(filterItem,index) in filteredItems" :key="index" class="project">
                    <div v-for="(item,index) in filterItem.items" :key="index">
                      <div class="row">
                        <h3 class="h3-list"><b>{{getLocation(item)}}</b><span class='box' :class="item['color']" style="float: left"></span></h3>
                      </div>
                        <p class="no-vertical-margin">
                            <span>{{item['Location address']}}</span><br>
                            <span v-if="item['Day']"><b>Hours:</b> {{item['Day']}} {{item['Times']}}</span><br/>
                            <span v-if="item['Website'] && item['Website'] != 'N/A'"> <a target="_blank" :href="item['Website']">Website</a><br/></span>
                        </p><br/>
                        <p class="no-vertical-margin">
                            <span><b>Contact Name:</b> {{item['Name'] || 'N/A'}}<br/></span>
                            <span><b>Contact Email:</b> {{item['Email'] || 'N/A'}}<br/></span>
                            <span><b>Contact Phone:</b> {{item['Phone'] || 'N/A'}}<br></span>
                            <span><b>Info:</b> {{item['Description'] || 'N/A'}}</span><br>
                            <span><b>Eligibility Requirements:</b> {{item['Eligibility requirements'] || 'N/A'}}</span><br>
                            <span><b>Registration Contact:</b> {{item['Registration Contact'] || 'N/A'}}</span><br>
                            <span><b>Languages Spoken other than English:</b> {{item['Languages Spoken other than English'] || 'N/A'}}</span><br>
                            <span><b>Metro:</b> {{item['Metro'] || 'N/A'}}<br/></span>
                            <span><b>Bus:</b> {{item['Bus'] || 'N/A'}}<br/></span>
                         </p><br/>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import R from 'ramda';
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps'
import { mapGetters, mapActions } from 'vuex';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDIkJCuWTcYkqhKmKQBKgsFvLJYeZxUu4U',
    libraries: 'places',
    v: 'beta'
  }
})

export default {
  name: 'foodResourceMap',
  data () {
    return {
      isMobile: false,
      showMap: true,
      mobileMenu: null,
      filtersExpanded: true,
      mapStyles: {styles: [{featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }]}]},
      civicAssocationsSelected: '',
      civicAssociationFailure: false,
      // map properties
      center: {
        lat: 38.8809462,
        lng: -77.099029
      },
      radiusSelected: '',
      icon: {
        path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
        fillColor: '#0040FF',
        fillOpacity: 1,
        strokeWeight: 0.5,
        strokeColor: '#fff',
        scale: 1,
        anchor: { x: 14, y: 10 } // eslint-disable-line no-undef
      },
      foodPantryIcon: {},
      schoolMealsIcon: {},
      restaurantIcon: {},
      discountGroceryIcon: {},
      farmersMarketIcon: {},
      shapeOptions: {
        strokeColor: '#0040FF',
        strokeOpacity: 0.9,
        strokeWeight: 4,
        fillColor: '#0040FF',
        fillOpacity: 0.35,
        zIndex: 2
      },
      locationOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
        zIndex: 1
      },
      addressPinOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.9
      },
      selectedCoordinates: null,
      selectedInfoWindowPosition: null,
      selectedItem: {},
      searchText: '',
      typeSelected: [],
      filterSelected: [],
      transitSelected: []
    }
  },
  computed: {
    ...mapGetters(['foodResources']),
    zoomLevel: function () {
      if (!this.selectedCoordinates && !this.civicAssocationsSelected) {
        return 13;
      }
      return 15;
    },
    mapCenter: function () {
      if (this.selectedCoordinates) {
        return this.selectedCoordinates;
      }
      return this.center;
    },

    filteredItems: function () {
      let items = this.foodResources;

      if (this.filterSelected.length > 0) {
        items = items.filter(item => this.filterSelected.some(selected => {
          return item[selected] && (item[selected].toUpperCase() === 'TRUE' || item[selected].toUpperCase() === 'X');
        }))
      }

      if (this.transitSelected.length > 0) {
        items = items.filter(item => this.transitSelected.some(selected => { return item[selected] }));
      }

      if (this.typeSelected.length > 0) {
        items = items.filter(item => { return this.typeSelected.includes(item['Type'].toString().toUpperCase()) })
      }

      const reducer = (groupBy, el) => {
        if (Array.isArray(el)) {
          return el.reduce(reducer, groupBy);
        } else {
          const { lat, lng, ...rest } = el;
          const group = groupBy.find(el => el.lat === lat && el.lng === lng);
          rest.color = rest['Type'].toUpperCase() === 'FOOD PANTRY' ? 'blue' : rest['Type'].toUpperCase() === 'SCHOOL MEALS' ? 'red' : rest['Type'].toUpperCase() === 'PREPARED MEALS' ? 'green' : 'purple';
          if (group) {
            group.items.push(rest);
          } else {
            groupBy.push({
              lat,
              lng,
              icon: rest.Type.toUpperCase() === 'FOOD PANTRY' ? this.foodPantryIcon : rest.Type.toUpperCase() === 'SCHOOL MEALS' ? this.schoolMealsIcon : rest.Type.toUpperCase() === 'PREPARED MEALS' ? this.restaurantIcon : rest.Type.toUpperCase() === 'DISCOUNT GROCERIES' ? this.discountGroceryIcon : this.icon,
              items: [rest]
            })
          }
          return groupBy;
        }
      }
      let items2 = items.reduce(reducer, []);
      return items2;
    }

  },
  mounted: function () {
    this.loadFoodResources();
    this.isMobile = window.innerWidth < 600;

    this.foodPantryIcon = {...this.icon};
    this.foodPantryIcon.fillColor = '#0040FF'; // blue

    this.schoolMealsIcon = {...this.icon};
    this.schoolMealsIcon.fillColor = '#ff0000';  // red

    this.restaurantIcon = {...this.icon};
    this.restaurantIcon.fillColor = '#009933'; // green

    this.discountGroceryIcon = {...this.icon};
    this.discountGroceryIcon.fillColor = '#990099'; // purple,
  },
  watch: {
  },
  methods: {
    ...mapActions(['loadFoodResources']),
    filtersToggle: function () {
      this.filtersExpanded = !this.filtersExpanded
    },
    clearAll () {
      this.typeSelected = [];
      this.filterSelected = [];
      this.selectedCoordinates = null;
      this.civicAssocationsSelected = '';
      this.$refs.autocomplete.$refs.input.value = '';
      this.radiusSelected = '';
    },
    placeChanged: function (place) {
      this.selectedCoordinates = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
    },
    setLocation: function (lat, lng) {
      this.selectedCoordinates = { lat: lat, lng: lng };
    },
    getCurrentLocation: function () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(pos => {
          this.selectedCoordinates = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        }, err => {
          alert('Unable to determine current location at this time.');
          return err;
        });
      }
    },
    shapeClick: function (item, clickEvent) {
      this.selectedItem = item;
      this.selectedInfoWindowPosition = clickEvent.latLng;
    },
    infoWindowCloseClick: function () {
      this.selectedItem = {};
      this.selectedInfoWindowPosition = null;
    },
    infoWindowCheck () {
      if (this.selectedItem && this.selectedItem.id) {
        const ifCheck = R.find(p => p.id === this.selectedItem.id)(this.filteredItems);
        if (ifCheck === null || ifCheck === undefined) {
          this.selectedItem = {};
          this.selectedInfoWindowPosition = null;
        }
      }
    },
    parentStatusClick (parentStatus) {
      var statusValues = R.map(R.prop('value'), parentStatus.subStatuses);
      statusValues.forEach(s => {
        const i = this.subStatusesSelected.indexOf(s.value);
        if (i >= 0) {
          this.subStatusesSelected.splice(i, 1);
        }
      });
    },
    getLocation (item) {
      let location = item['Organization'];

      location += item['Co-Sponsor'] !== null ? ' with ' + item['Co-Sponsor'] : '';

      location += item['Organization'] !== item['Location name'] ? ' at ' + item['Location name'] : '';

      return location;
    },
    ageRestrictionChange: function (ev) {
      if (this.filterSelected.includes('age_restriction')) {
        this.filterSelected.push('Age restrictions - for children (or families of children) only')
        this.filterSelected.push('Age restrictions - for seniors only')
      } else {
        this.filterSelected.splice(this.filterSelected.indexOf('Age restrictions - for children (or families of children) only'), 1)
        this.filterSelected.splice(this.filterSelected.indexOf('Age restrictions - for seniors only'), 1)
      }
    }
  }
}

</script>

<style lang="scss" scoped>
    .filter-category {
      font-weight: bold;
      font-size: 1.45em;
    }

    .toggle-link {
      cursor: pointer;
      padding: 0 12px;
      color: #e87c1a;
    }

    .active {
      color: #015cb9;
    }

    .toggle-window {
      border: 2px solid #f1f1f1;
      padding: 8px;
      margin-bottom: 4px;
    }

    #list-link {
      border-left: 2px solid #f1f1f1;
    }

    .toggle-bar {
      padding-bottom: 8px;
      border-bottom: 2px solid #f1f1f1;
    }

    p.no-vertical-margin {
      margin-bottom: 0;
      margin-top: 0;
    }

    .project {
      margin-bottom: 1rem;
    }

.list-pane {
  overflow-y: scroll;
}

.operations-list {
  li {
    font-size: 1em;
    padding: 0px;
  }
}

.h3-list {
  margin: 0px;
}

.column {
  float: left;
  width: 50%;
  min-width: 145px;
  min-height: 55px;
}

.info-window-header {
  margin: 0px;
}

.info-window-body {
  clear: both;
}

.header-column-left {
  float: left;
  width: 75%;
  min-height: 30px;
}

.header-column-right {
  float: left;
  width: 25%;
  min-width: 15px;
  min-height: 30px;
  margin-bottom: 3px;
  height: auto;
  span {
    font-size: 20px;
  }
}

.list-header-column-left {
  float: left;
  width: 75%;
  min-height: 25px;
}

.list-header-column-right {
  float: left;
  width: 25%;
  min-width: 15px;
  min-height: 25px;
  margin-bottom: 1px;
  height: auto;
  span {
    font-size: 20px;
    margin-top: 6px;
  }
}

.row:after {
  display: table;
  clear: both;
}

.transit-row {
  font-size: 20px;
}

.filter-item-nested {
  margin-left: 10px;
}

.box {
  float: right;
  height: 16px;
  width: 16px;
  margin-left: 5px;
  margin-right: 5px;
  margin-top: 3px;
  border: 1px solid black;
  clear: both;
}

.red {
  background-color: #ff0000;
}

.purple {
  background-color: #990099;
}

.green {
  background-color: #009933;
}

.blue {
  background-color: #0040FF;
}

.orange {
  background-color: #ff6633;
}
@media (max-width: 650px) {
  .list-pane {
    max-height: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// foodResources.vue?1291ef07